module.exports = __webpack_public_path__ + "media/images/top/budget_table/corporation_pc-b50abe1c6d1b0c804d6691c098dc8ef5.png";